exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".myswitch-wrapper{overflow:hidden;height:30px;width:5pc;border-radius:4px;cursor:pointer}.inframe{position:relative;width:140px;height:30px;left:0}.inframe,.inframe.off{-webkit-transition:left .3s ease;transition:left .3s ease}.inframe.off{left:-60px}.handle{width:20px;background-color:#0bbd9e}.handle,.off-text,.on-text{float:left;height:30px;border-width:0}.off-text,.on-text{width:60px;text-align:center;line-height:30px;color:#0bbd9e;background-color:#34495d}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/selector.js?type=style&index=0!./src/controls/custom-switch.vue
// module id = 63
// module chunks = 0